import React, { useState } from "react";
import { Col } from "antd";
import {
  EditFilled,
  OrderedListOutlined,
  UnorderedListOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";
import { BsCode } from "react-icons/bs";
import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import "./textEidtor.css";

let showhtml = true;
let buttonDisable = false;
window.temp = "";
let htmlText = "";

function conversion() {
  if (showhtml) {
    htmlText = window.temp;
    this.quill.setText(window.temp);
    buttonDisable = true;
    showhtml = false;
  } else {
    buttonDisable = false;
    this.quill.clipboard.dangerouslyPasteHTML(htmlToText(window.temp));
    //this.quill.clipboard.dangerouslyPasteHTML(window.temp);
    showhtml = true;
  }
}

function htmlToText(html) {
  var temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent; // Or return temp.innerText if you need to return only visible text. It's slower.
}

const CustomToolbar = () => {
  return (
    <div id="toolbar">
      <div className="buttonStyle">
        <button className="ql-bold boldButtonStyle" disabled={buttonDisable} />
        <button
          className="ql-italic italicButtonStyle"
          disabled={buttonDisable}
        />
        <button
          className="ql-underline UnderlineButtonStyle"
          disabled={buttonDisable}
        />
        <button
          className="ql-list buttonSty"
          value="ordered"
          disabled={buttonDisable}
        >
          <UnorderedListOutlined />
        </button>
        <button
          className="ql-list buttonSty"
          value="bullet"
          disabled={buttonDisable}
        >
          <OrderedListOutlined />
        </button>
        <button
          className="ql-indent buttonSty"
          value="+1"
          disabled={buttonDisable}
        />
        <button
          className="ql-indent buttonSty"
          value="-1"
          disabled={buttonDisable}
        />
        <button className="ql-conversion penSty">
          <BsCode style={{ color: "#1e1e1e" }} />
        </button>
      </div>
    </div>
  );
};

/*
 * Editor component with custom toolbar and content containers
 */
class Editor extends React.Component {
  state = {
    editorHtml: this.props.text || "",
    editorVal: '',
    quillRef: null,
    reactQuillRef: null,
    counter: 0,
    show: this.props.FromSellJob,
    error: false
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // setTimeout(() => {
    //   this.handleChange(this.props.text);
    // }, 1)
    this.setState({counter : this?.props?.text?.replace(/<(.|\n)*?>/g, '')?.length > 0 ? this?.props?.text?.replace(/<(.|\n)*?>/g, '')?.length : 0})
    setTimeout(() => {
      this.setState({ show: true });
    }, 200);
    this.attachQuillRefs();
  }

  componentDidUpdate() {
    this.attachQuillRefs();
    // this.props?.counter(`${this.state?.counter - 1}`);
    if (this.props.counter) this.props.counter(`${this.state.counter - 1}`);
  }

  attachQuillRefs = () => {
    if (typeof this.reactQuillRef?.getEditor !== "function") return;
    this.quillRef = this.reactQuillRef?.getEditor();
  };
  // handleChange = (html) => {
  //   this.setState({ editorHtml: html });
  //   window.temp=html;
  //   this.props.changeText(html);
  // };

  handleSpaceKeyPress = (event) => {
    const decodedHtml = new DOMParser().parseFromString(
      this.state.editorHtml,
      "text/html"
    ).body.textContent;
    const cleanedHtml = decodedHtml.replace(/<p>\s+<\/p>/g, "");
    if (!cleanedHtml) {
      if (event.key === " ") {
        event.preventDefault(); // Prevent the default space key behavior
      }
    }
  };

  handleChange = (html) => {
    var limit = 5000;
    var quill = this.quillRef;

    this.props.FromPostAJob !== false &&
      quill?.on("text-change", function (delta, old, source, editor) {
        if (quill?.getLength() > limit) {
          quill.deleteText(limit, quill?.getLength());
        }
      });
    window.temp = html;
    const decodedHtml = new DOMParser().parseFromString(html, "text/html").body
      .textContent;
    const cleanedHtml = decodedHtml.replace(/<p>\s+<\/p>/g, "");
    if (cleanedHtml[0] != " ") {
      this.setState({ editorHtml: html });
    }
    if (quill) {
      quill.container.addEventListener("keydown", this.handleSpaceKeyPress);
    }
    this.props.changeText(html); //html
    if(this.props.error) {
      this.props.setError(false)
    } 
    this.setState({ counter: quill?.getLength() - 1 });
  };

  static modules = {
    toolbar: {
      container: "#toolbar",
      handlers: {
        conversion: conversion,
      },
    },
  };

  static formats = ["bold", "italic", "underline", "list", "bullet", "indent"];

  render() {
    return (
      <div>
        <CustomToolbar />
        <div className="editorArea">
          {this.state.show ? (
            <ReactQuill
            className={this.props?.error ? "error-class" : "fine-class"}
              ref={(el) => {
                this.reactQuillRef = el;
              }}
              value={this.state.editorHtml || ""}
              onChange={this.handleChange}
              placeholder={this.props.placeholder}
              modules={Editor.modules}
              formats={Editor.formats}
            />
          ) : (
            ""
          )}
        </div>
        {this.props.FromPostAJob === false ? null : (
          <p className="counter_div">
            {`${
              isNaN(this?.state.counter)
                ? 0
                : this?.state.counter > 0
                ? this?.state.counter
                : this?.state?.counter === 0
                ? this?.state?.counter
                : this.state.counter - 1
            }` + "/5000"}
          </p>
        )}
      </div>
    );
  }
}

export default Editor;
